import { initAllAutocomplete as initAllAutocompleteImp } from '~/src/client/javascripts/autocomplete.js'
import { initFileUpload as initFileUploadImp } from '~/src/client/javascripts/file-upload.js'
import { initAllGovuk as initAllGovukImp } from '~/src/client/javascripts/govuk.js'
import { initPreviewCloseLink as initPreviewCloseLinkImp } from '~/src/client/javascripts/preview-close-link.js'
export { initMaps } from '~/src/client/javascripts/map.js'
export * as map from '~/src/client/javascripts/map.js'
export * as geospatialMap from '~/src/client/javascripts/geospatial-map.js'

export const initAllGovuk = initAllGovukImp
export const initAllAutocomplete = initAllAutocompleteImp
export const initFileUpload = initFileUploadImp
export const initPreviewCloseLink = initPreviewCloseLinkImp

/**
 * Initialise all clientside components (but not maps as this will be an opt-in for now given the additional UMD assets that are required)
 */
export function initAll() {
  initAllGovuk()
  initAllAutocomplete()
  initFileUpload()
  initPreviewCloseLink()
}
